export class InterfaceElementDataTypes {
  public static readonly BooleanDT = 'cbc99b38-2c94-46ae-a1d3-2b24e5850ced';
  public static readonly ByteDT = '0a0965ca-b6d4-4982-a798-1272f01c84c9';
  public static readonly CharDT = '4e41a6bb-cf97-4b94-aac0-800617b24bf5';
  public static readonly DateDT = '5f78d6cd-acc3-4b44-aa68-ca931cb91e07'; //
  public static readonly DecimalDT = 'a6552837-99f8-4de2-8ba3-2411b71eb32e';
  public static readonly DoubleDT = '5c86b0fc-4513-4b68-8bb9-10a6a8963ae1';
  public static readonly FloatDT = 'bd251ee3-aded-4afd-9df1-f5631d1a98fd';
  public static readonly GuidDT = '0ad2c1b1-21fa-4b78-aa7f-cdbe592d701a';
  public static readonly ImageDT = 'bb5f66ce-5768-428b-af8f-a7ff160ce517';
  public static readonly IntegerDT = '18bdd9b1-ce94-452b-9249-5c294e040df5'; //
  public static readonly LongDT = '8ac3ecac-4802-46dc-8f26-e5fa5d50255c';
  public static readonly LockUpItemDT = 'e2702169-78d6-4c6d-85db-c325c5ddd9e2';
  public static readonly ShortDT = 'f7d1a64c-32bb-41bb-b1da-913589a1b109';
  public static readonly StringDT = 'c9a7ee75-f530-44ee-bdee-aa684604be8e';
  public static readonly PicklistDT = '85755da6-b68b-41b5-a1e0-7d26bfe1b3d0';
  public static readonly ResorceDT = '8e83be77-6176-43d9-b39a-dc8d9894cb15';
}
